const getDeliveryEstimation = (shippingInfo, intl)=>{
    const { getFormattedLabel , dateTime: { formatDate  } ,  } = intl;
    const estimation = shippingInfo.expectedDeliveryEstimation;
    if (!estimation) {
        return '';
    }
    switch(estimation.__typename){
        case 'DateEstimation':
            const date = new Date(estimation.deliveryDate);
            if (date instanceof Date && isNaN(date.getTime())) {
                return '';
            }
            return getFormattedLabel('products.deliveryIndicator.deliveryIndicationFullDate', {
                labelData: {
                    deliveryDate: formatDate(date, 'short')
                }
            });
        case 'RangeEstimation':
            return getFormattedLabel('products.deliveryIndicator.shortDeliveryIndication', {
                labelData: {
                    days: `${estimation.deliveryRange.min}-${estimation.deliveryRange.max}`
                }
            });
        default:
            return '';
    }
};

export { getDeliveryEstimation };
//# sourceMappingURL=get-delivery-estimation.js.map
